import { Paper, styled } from "@mui/material";

export const FloatingActionBarContainer = styled(Paper)<{ bottom: string }>`
  z-index: 1;

  &.MuiPaper-root {
    background: ${(props) => props.theme.wsc.palette.neutral[800]};
    border: 2px solid ${(props) => props.theme.wsc.palette.neutral[600]};
    border-radius: ${(props) => props.theme.wsc.radius.l};
    padding: ${(props) => props.theme.wsc.spacing[2]};
    position: fixed;
    bottom: ${(props) => props.bottom};
    left: 0;
    right: 0;
    margin: 0 auto;
    width: fit-content;
  }
`;
